import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { convertToInlineCss } from '@atlaskit/editor-common/lazy-node-view';
import { browser } from '@atlaskit/editor-common/utils';
import { ZERO_WIDTH_SPACE } from '@atlaskit/editor-common/whitespace';
import { fg } from '@atlaskit/platform-feature-flags';

// eg. Version/4.0 Chrome/95.0.4638.50
var isAndroidChromium =
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
typeof window !== 'undefined' && /Version\/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])* Chrome\/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*/.test(window.navigator.userAgent);
export var statusToDOM = function statusToDOM(node) {
  var _node$attrs = node.attrs,
    text = _node$attrs.text,
    color = _node$attrs.color,
    style = _node$attrs.style,
    localId = _node$attrs.localId;
  var editorNodeWrapperAttrs = {
    class: 'statusView-content-wrap inlineNodeView',
    'data-testid': 'statusContainerView',
    'data-prosemirror-node-name': 'status',
    localid: localId
  };
  var statusElementAttrs = {
    style: convertToInlineCss(isAndroidChromium ? {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
      display: 'inline-block !important',
      verticalAlign: 'middle'
    } : {}),
    class: 'status-lozenge-span',
    'data-node-type': 'status',
    'data-color': color,
    'data-style': style
  };
  var lozengeWrapperAttrs = {
    class: 'lozenge-wrapper'
  };
  var lozengeTextAttrs = {
    class: 'lozenge-text',
    style: convertToInlineCss(_objectSpread({}, fg('platform-lozenge-custom-letterspacing') ? {
      // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
      letterSpacing: '0.165px'
    } : {}))
  };
  return ['span', editorNodeWrapperAttrs, ['span', {
    class: 'zeroWidthSpaceContainer'
  }, ['span', {
    class: 'inlineNodeViewAddZeroWidthSpace'
  }, ZERO_WIDTH_SPACE]], ['span', statusElementAttrs, ['span', lozengeWrapperAttrs, ['span', lozengeTextAttrs, text]]], browser.android ? ['span', {
    class: 'zeroWidthSpaceContainer',
    contentEditable: 'false'
  }, ['span', {
    class: 'inlineNodeViewAddZeroWidthSpace'
  }, ZERO_WIDTH_SPACE]] : ['span', {
    class: 'inlineNodeViewAddZeroWidthSpace'
  }, '']];
};